import { render, staticRenderFns } from "./AIWarnDetail.vue?vue&type=template&id=118053f8&scoped=true&"
import script from "./AIWarnDetail.vue?vue&type=script&lang=js&"
export * from "./AIWarnDetail.vue?vue&type=script&lang=js&"
import style0 from "./AIWarnDetail.vue?vue&type=style&index=0&id=118053f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118053f8",
  null
  
)

export default component.exports